export default "__VITE_ASSET__C8wk1sMr__"